import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import { buildUrl } from '../../../utils/buildUrl.js';
import { makeLongRequest, METHODS } from '../../baseRequest.js';
import { PLATFORMS } from '../../../constants/platforms.js';
import settings from '../../../settings.js';

function steamPurchaseStatus(id) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = buildUrl(settings.steamPurchaseStatusUrl, {
            id,
            platform: PLATFORMS.STEAM,
            backendUrl: settings.backendUrl,
            language: settings.language,
            storefrontName: settings.storefrontName,
        });
        return makeLongRequest(METHODS.GET, url);
    });
}

export { steamPurchaseStatus };
//# sourceMappingURL=steamPurchaseStatus.js.map
